<template>
  <div class="goods1">
    <div class="mb20">可以至多选择4条新闻，10条动态。可以拖动排序</div>
    <h1>公司新闻</h1>
    <draggable
      v-model="currentInfo.wxSchoolPageItemList"
      @update="datadragEndContent"
      :options="{ animation: 500 }"
    >
      <div
        v-for="(item, index) in currentInfo.wxSchoolPageItemList"
        :key="'1' + index"
      >
        <div
          class="flex jc-sb cp wx-item-style"
          @click="addGoodSingleBtn(index)"
          v-if="index < 4"
        >
          <div class="ellipsis">{{ item.schoolPageInfo.title }}</div>
          <el-button
            type="danger"
            icon="el-icon-delete"
            size="mini"
            @click.stop="deleteBtn(index)"
          ></el-button>
        </div>
      </div>
    </draggable>
    <h1>行业动态</h1>
    <draggable
      v-model="currentInfo.wxSchoolPageItemList"
      @update="datadragEndContent"
      :options="{ animation: 500 }"
    >
      <div
        v-for="(item, index) in currentInfo.wxSchoolPageItemList"
        :key="'2' + index"
      >
        <div
          class="flex jc-sb cp wx-item-style"
          @click="addGoodSingleBtn(index)"
          v-if="index > 3"
        >
          <div class="ellipsis">{{ item.schoolPageInfo.title }}</div>
          <el-button
            type="danger"
            icon="el-icon-delete"
            size="mini"
            @click.stop="deleteBtn(index)"
          ></el-button>
        </div>
      </div>
    </draggable>
  </div>
</template>
<script>
import { codeMixin } from "../../../minix";
export default {
  mixins: [codeMixin],

  methods: {
    deleteBtn(index) {
      this.$confirm("确认删除？")
        .then((_) => {
          this.currentInfo.wxSchoolPageItemList[index].isEmpty = 1;
          this.currentInfo.wxSchoolPageItemList[index].relationId = "";
          this.currentInfo.wxSchoolPageItemList[index].schoolPageInfo = {};
        })
        .catch((_) => {});
    },
    //选单个
    addGoodSingleBtn(index) {
      this.$store.commit("design/SET_ADDDIALOGVISIBLE", {
        addDialogVisible: true,
        single: true,
        singleIndex: index,
      });
    },
  },
};
</script>
<style lang="less" scoped>
.goods1 {
  /deep/ .el-upload {
    width: 100px;
    height: 100px;
    border: 1px dashed rgb(196, 192, 192);
    display: flex;
    border-radius: 6px;
    align-items: center;
    justify-content: center;
    .el-icon-plus {
      font-size: 36px;
    }
    img {
      max-width: 100%;
      max-height: 100%;
      object-fit: cover;
    }
  }
  .jc-sb {
    width: 100%;
    padding: 10px;
    box-sizing: border-box;
    margin-top: 10px;

    border-radius: 6px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/designPage/template/propaganda/propaganda2/setting.vue